/*
    Event.js - Event model
 */
import {Rest, State} from '@embedthis/devcore'

export default new Rest('event', {}, {

    //  Tunnel when used by CloudKick
    tunnel: 'Event',
    context: (body) => {
        if (State.config.name == 'CloudKick') {
            body.deviceId = State.context.deviceId
        }
        return body
    }
})
    